// // Imports
// import { withStyles } from '@material-ui/core';
// import React, { PureComponent } from 'react';
// import { connect } from 'react-redux';
// import 'react-bootstrap';
// import { Container, Row, Col } from "react-bootstrap";
// import routes from '../api/routes';
// import { Link, withRouter } from 'react-router-dom';
// import Tab from "react-bootstrap/Tab";
// import Tabs from "react-bootstrap/Tabs";
// import PropTypes from "prop-types";
// import styles from './styles';
// import Contactss from '../contacts/list';


// // Component
// class List extends PureComponent {
//   constructor(props) {
//     super(props);
//     this.state = {
//       activeTab: this.getActiveTabFromPath(props.location.pathname, props.location.state),
//     };
//   }

//   getActiveTabFromPath(path, state) {
//     if (state && state.activeTab) {
//       return state.activeTab;
//     }
//     if (path.includes(routes.listContacts.path)) {
//       return 'Contacts';
//     }
//     else if (path.includes(routes.listAllTabs.path)) {
//       return 'Leads';
//     }
//     else if (path.includes(routes.listAllTabs.path)) {
//       return 'Prospect';
//     }
//     else if (path.includes(routes.listAllTabs.path)) {
//       return 'Customer';
//     }
//     return 'Contacts';
//   }

//   handleSelect = (key) => {
//     this.setState({ activeTab: key }, () => {
//       if (key === 'Contacts') {
//         this.props.history.push(routes.listContacts.path, { activeTab: key });
//       } else if (key === 'Leads') {
//         this.props.history.push(routes.listAllTabs.path, { activeTab: key });
//       } else if (key === 'Prospect') {
//         this.props.history.push(routes.listAllTabs.path, { activeTab: key });
//       } else if (key === 'Customer') {
//         this.props.history.push(routes.listAllTabs.path, { activeTab: key });
//       }
//     });
//   };


//   render() {
//     const { classes } = this.props;
//     const { activeTab } = this.state;
//     return (
//       <section id="menu" className="mt-5">
//         <div className="clearfix mb-5 pb-5">
//           <Container fluid>
//             <Row className="mb-10 justify-content-center">
//               <Col>
//                 <Tabs
//                   activeKey={activeTab}
//                   onSelect={this.handleSelect}
//                   transition={false}
//                 >
//                   <Tab
//                     eventKey="Contacts"
//                     title={<h1 style={{ fontSize: '15px'}}>Contacts</h1>}
//                     style={{ color: 'blue' }}
//                   >
//                   <Contactss/>
//                   </Tab>
//                   <Tab
//                     eventKey="Leads"
//                     title={<h1 style={{ fontSize: '15px' }}>Leads</h1>}
//                   >

//                   </Tab>
//                   <Tab
//                     eventKey="Prospect"
//                     title={<h1 style={{ fontSize: '15px' }}>Prospect</h1>}
//                   >

//                   </Tab>
//                   <Tab
//                     eventKey="Customer"
//                     title={<h1 style={{ fontSize: '15px' }}>Customer</h1>}
//                   >

//                   </Tab>
//                 </Tabs>
//               </Col>
//             </Row>
//           </Container>
//         </div>
//       </section>
//     );
// }
// }

// List.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

// export default withRouter(connect(null, {})(withStyles(styles)(List)));


// Imports
import React, { PureComponent, useState } from "react";
import { connect } from "react-redux";
import "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import { withRouter, Link } from "react-router-dom";
// import Tab from "react-bootstrap/Tab"; // Removing Boostrap Tab
// import Tabs from "react-bootstrap/Tabs"; // Removing Boostrap Tabs
import { Tabs, Tab } from "@mui/material"; // Using MUI Tabs
import PropTypes from "prop-types";
// import Points from "../Points";
// import Goals from "../listGoals";
import Contacts from "../contacts/list";
import BrandedLoading from "../../common/BrandedLoading"
import { getTemplates, listContact } from "../api/actions/query";
import { formatAssigneeName } from "../../../setup/helpers";

// import { listGoals } from "../api/actions/query";
import { messageShow } from "../../common/api/actions";
import { remove, updateLeadStatus } from "../api/actions/mutation";
// import { listrewards } from "../apiRewards/actions/query";
// import { removeReward } from "../apiRewards/actions/mutation";
import { ReactComponent as YelpIcon } from "../../../assets/icons/yelp.svg";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { FileUpload, FileDownload, Search, Close, Settings, Unsubscribe as UnsubscribeIcon } from "@mui/icons-material";
import { checkPermission } from "../../common/Sidebar/checkPermission";
import { Button, InputAdornment, MenuItem, TextField, Card, CardContent, Typography, Box, LinearProgress, Menu, Chip, Autocomplete } from "@mui/material";
import {Contacts as ContactIcon,
  TrendingUp as LeadIcon,
  Star as ProspectIcon,
  VerifiedUser as CustomerIcon,
  FilterList as FilterListIcon,
  InfoOutlined } from "@mui/icons-material";
import Popover from "@mui/material/Popover";
import TemplateSelectionPopup from "./Messaging";

function FiltersPopover({ filters, setFilters, clearFilters, availableTags = [], availableIndustryTypes = [] }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const hasActiveFilters = Boolean(
    filters.customerType ||
    filters.industryType ||
    (filters.tags && filters.tags.length > 0) ||
    filters.startDate ||
    filters.endDate
  );

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<FilterListIcon />}
        onClick={handleOpen}
        sx={{ 
            borderRadius: '10px', 
            height: 40, 
            ml: 1, 
            borderColor: hasActiveFilters ? '#3b82f6' : '#e5e7eb',
            bgcolor: hasActiveFilters ? '#eff6ff' : 'transparent',
            color: hasActiveFilters ? '#1d4ed8' : '#4b5563',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': {
                bgcolor: hasActiveFilters ? '#dbeafe' : '#f9fafb',
                borderColor: hasActiveFilters ? '#2563eb' : '#d1d5db'
            }
        }}
      >
        {hasActiveFilters ? "Filter (Active)" : "Filter"}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{ sx: { borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', p: 1 } }}
      >
        <div style={{ padding: 12, width: 320 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: '#1e293b' }}>
            Filter Contacts
          </Typography>

          <TextField
            label="Customer Type"
            placeholder="e.g. Corporate, Individual"
            value={filters.customerType || ""}
            onChange={(e) => setFilters({ customerType: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
          />

          <Box sx={{ mt: 1 }}>
            <Autocomplete
              freeSolo
              options={availableIndustryTypes}
              value={filters.industryType || ""}
              onChange={(_, newValue) => setFilters({ industryType: newValue || "" })}
              onInputChange={(_, newInputValue) => setFilters({ industryType: newInputValue })}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Industry Type"
                  placeholder="Select or enter industry type"
                  size="small"
                  margin="dense"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                />
              )}
            />
          </Box>

          <Box sx={{ mt: 1 }}>
            <Autocomplete
              multiple
              freeSolo
              options={availableTags}
              value={filters.tags || []}
              onChange={(_, newValue) => setFilters({ tags: newValue })}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    key={option}
                    variant="outlined"
                    label={option}
                    size="small"
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Tags"
                  placeholder="Select or type tags"
                  size="small"
                  margin="dense"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                />
              )}
            />
          </Box>

          <Box sx={{ mt: 1.5, mb: 1 }}>
            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600, display: "block", mb: 0.5 }}>
              Date Joined Range
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                label="From"
                type="date"
                size="small"
                value={filters.startDate || ""}
                onChange={(e) => setFilters({ startDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
              />
              <TextField
                label="To"
                type="date"
                size="small"
                value={filters.endDate || ""}
                onChange={(e) => setFilters({ endDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
              />
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                clearFilters();
                handleClose();
              }}
              fullWidth
              sx={{ 
                  borderRadius: '8px', 
                  textTransform: 'none',
                  fontWeight: 600,
                  color: '#475569',
                  borderColor: '#cbd5e1'
              }}
            >
              Clear All
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleClose}
              fullWidth
              sx={{ 
                  bgcolor: '#0d3559', 
                  color: 'white',
                  borderRadius: '8px', 
                  textTransform: 'none',
                  fontWeight: 600,
                  boxShadow: 'none',
                  '&:hover': { bgcolor: '#092a46', boxShadow: 'none', color: 'white' } 
              }}
            >
              Apply
            </Button>
          </Box>
        </div>
      </Popover>
    </>
  );
}

const StatsCard = ({ title, count, total, color, icon }) => {
  const percentage = total > 0 ? Math.round((count / total) * 100) : 0;
  return (
    <Card sx={{ height: '100%', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)', borderRadius: '16px', border: '1px solid #f3f4f6', overflow: 'visible' }}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
            <Box>
                <Typography color="textSecondary" gutterBottom variant="overline" sx={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', color: '#9ca3af' }}>
                {title}
                </Typography>
                <Typography variant="h4" component="div" sx={{ fontWeight: 800, color: '#111827' }}>
                {count}
                </Typography>
            </Box>
            <Box
                sx={{
                    width: 40, height: 40,
                    borderRadius: '10px',
                    bgcolor: `${color}15`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: color
                }}
            >
                {icon}
            </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <Box sx={{ width: '100%', mr: 1.5 }}>
            <LinearProgress
              variant="determinate"
              value={percentage}
              sx={{
                height: 6,
                borderRadius: 5,
                backgroundColor: '#f3f4f6',
                '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 5 }
              }}
            />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="textSecondary" sx={{ fontSize: 12, fontWeight: 600 }}>{`${percentage}%`}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

// Component
class List extends PureComponent {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(props.location.search);
    const tabParam = params.get("tab") || props.location?.state?.activeTab || "Contacts";
    this.state = {
      activeTab: tabParam,
      contacts: [],
      leads: [],
      prospects: [],
      customers: [],
      unsubscribed: [],
      isLoading: false,
      permissions: {
        contactsPermissions:{},
        leadsPermissions:{},
        prospectPermissions:{},
        customerPermissions: {},
        yelpPermissions: {},
        crmPermissions :{},
        clientConfigPermissions: {},
      },
      filters: {
        searchTerm: "",
        customerType: "",
        industryType: "",
        tags: [],
        startDate: "",
        endDate: "",
      },
        templates: [],
        templatePopupOpen: false,
        selectedContactId: null,
    };
  }

  componentDidMount() {
    this.refresh();
    // this.refreshReward();
    this.fetchPermissions()
    this.fetchTemplates();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.state.permissions) {
      this.updateActiveTabBasedOnPermissions();
    }
  }

  handleSelect = (newTab) => {
    const params = new URLSearchParams(this.props.location.search);
    params.set("tab", newTab);
    this.props.history.replace({ search: params.toString() });
    this.setState({ activeTab: newTab });
  };

  updateActiveTabBasedOnPermissions = () => {
    const { permissions, activeTab } = this.state;
    if (activeTab === "Unsubscribed") {
      return;
    }
    const tabPermissions = {
      contactsPermissions: "Contacts",
      leadsPermissions: "Leads",
      prospectPermissions: "Prospect",
      customerPermissions: "Customer"
    };

    let newTab = activeTab;
    if (!newTab) {
      for (const [permission, tab] of Object.entries(tabPermissions)) {
        if (permissions[permission]?.canView) {
          newTab = tab;
          break;
        }
      }
    }

    if (newTab !== activeTab || !new URLSearchParams(this.props.location.search).get("tab")) {
      const params = new URLSearchParams(this.props.location.search);
      params.set("tab", newTab);
      this.props.history.replace({ search: params.toString() });
      this.setState({ activeTab: newTab });
    }
  };

  refresh = async () => {
    const { listContact, messageShow } = this.props;
    this.setState({ isLoading: true });
    try {
      const { data } = await listContact();
      if (data.success) {
        const contacts = data.data || [];
        this.setState({
          allLoadedContacts: contacts,
          contacts: contacts.filter(
            (contact) => !contact.leadStatus || contact.leadStatus === "Contact" || contact.leadStatus.toLowerCase() === "contact"
          ),
          leads: contacts.filter((contact) => contact.leadStatus === "Lead" || contact.leadStatus?.toLowerCase() === "lead"),
          prospects: contacts.filter(
            (contact) => contact.leadStatus === "Prospect" || contact.leadStatus?.toLowerCase() === "prospect"
          ),
          customers: contacts.filter(
            (contact) => contact.leadStatus === "Customer" || contact.leadStatus?.toLowerCase() === "customer"
          ),
          unsubscribed: contacts.filter(
            (contact) => contact.emailSubscription === false
          ),
        });
      } else {
        messageShow(data.message);
      }
    } catch (error) {
      messageShow("There was some error. Please try again.");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  setFilters = (newFilters) => {
    this.setState((prevState) => ({
      filters: { ...prevState.filters, ...newFilters },
    }));
  };

  clearFilters = () => {
    this.setState({
      filters: {
        searchTerm: "",
        customerType: "",
        industryType: "",
        tags: [],
        startDate: "",
        endDate: "",
      },
    });
  };

  fetchTemplates = async () => {
    try {
        const response = await getTemplates();
        if (response) {
            this.setState({
              templates: response.data.data
            })
        }
    } catch (error) {
        console.error("Failed to fetch templates:", error);
    }
  };
  handleSendClick = (contactId) => {
    this.setState({ selectedContactId: contactId, templatePopupOpen: true });
  };

  handleCloseTemplatePopup = () => {
    this.setState({ templatePopupOpen: false, selectedContactId: null });
  };

  fetchPermissions = async () => {
    const crmPermissions = await checkPermission("engagement", "crm")
    const contactsPermissions = await checkPermission("engagement", "crm.contacts");
    const leadsPermissions = await checkPermission("engagement", "crm.lead");
    const prospectPermissions = await checkPermission("engagement", "crm.prospect");
    const customerPermissions = await checkPermission("engagement", "crm.customer");
    const yelpPermissions = await checkPermission("engagement", "crm.yelp");
    const clientConfigPermissions = await checkPermission("engagement", "crm.clientConfig");
    this.setState({permissions:{contactsPermissions,leadsPermissions,prospectPermissions,customerPermissions,yelpPermissions,crmPermissions,clientConfigPermissions}})
  }
  // openMessagingDialog = (rewardId) => {
  //   this.setState({ messageDialogOpen: true, selectedRewardId: rewardId });
  // };

  // closeMessagingDialog = () => {
  //   this.setState({ messageDialogOpen: false, selectedRewardId: null });
  // };

  // refreshReward = async () => {
  //   const { listrewards } = this.props;
  //   this.isLoadingToggle(true)
  //   try {
  //     const { data } = await listrewards()
  //     if (data.success) {
  //       this.setState({
  //         rewards: data.data,
  //       })
  //     } else {
  //       messageShow(data.message)
  //     }
  //   } catch (error) {
  //     messageShow('There was some error. Please try again.')
  //   } finally {
  //     this.isLoadingToggle(false)
  //   }
  // }

  handleSelectGoal = (contactId) => {
    this.setState((prevState) => {
      const newSelectedGoals = { ...prevState.selectedContact };
      if (newSelectedGoals[contactId]) {
        delete newSelectedGoals[contactId];
      } else {
        newSelectedGoals[contactId] = true;
      }
      return { selectedContact: newSelectedGoals };
    });
  };

  isGoalExpired = (goal) => {
    return goal.isExpired;
  };

  handleSelectAllGoals = () => {
    const { contacts, selectedContact } = this.state;
    const newSelectedGoals = {};

    const enabledGoals = contacts.filter(goal => !this.isGoalExpired(goal));

    if (Object.keys(selectedContact).length !== enabledGoals.length) {
      enabledGoals.forEach(goal => {
        newSelectedGoals[goal._id] = true;
      });
    }

    this.setState({ selectedContact: newSelectedGoals });
  };

  handleSelectReward = (rewardId) => {
    this.setState((prevState) => {
      const newSelectedRewards = { ...prevState.selectedRewards };
      if (newSelectedRewards[rewardId]) {
        delete newSelectedRewards[rewardId];
      } else {
        newSelectedRewards[rewardId] = true;
      }
      return { selectedRewards: newSelectedRewards };
    });
  };

  isRewardExpired = (reward) => {
    return reward.isExpired;
  };

  handleSelectAllRewards = () => {
    const { rewards, selectedRewards } = this.state;
    const newSelectedRewards = {};

    const enabledRewards = rewards.filter(reward => !this.isRewardExpired(reward));

    if (Object.keys(selectedRewards).length !== enabledRewards.length) {
      enabledRewards.forEach(reward => {
        newSelectedRewards[reward._id] = true;
      });
    }

    this.setState({ selectedRewards: newSelectedRewards });
  };


  onDelete = async (contactId) => {
    if (window.confirm("Are you sure you want to delete this contact?")) {
      try {
        const { data } = await remove({ contactId });
        this.props.messageShow(data.message);
        if (data.success) {
          this.setState(prevState => ({
            contacts: prevState.contacts.filter(contact => contact._id !== contactId),
            leads: prevState.leads.filter(contact => contact._id !== contactId),
            prospects: prevState.prospects.filter(contact => contact._id !== contactId),
            customers: prevState.customers.filter(contact => contact._id !== contactId),
            unsubscribed: (prevState.unsubscribed || []).filter(contact => contact._id !== contactId),
          }));
        }
      } catch (error) {
        console.error("Error deleting contact:", error);
        this.props.messageShow("Some error occurred. Please try again.");
      }
    }
  };
  // onDeleteReward = async () => {
  //   const { selectedRewards } = this.state;

  //   const rewardIdsToDelete = Object.keys(selectedRewards).filter(rewardId => selectedRewards[rewardId]);

  //   const check = window.confirm(
  //     `Are you sure you want to delete ${rewardIdsToDelete.length} selected reward(s)?`
  //   );

  //   if (check) {
  //     const { removeReward, messageShow } = this.props;

  //     try {
  //       const removedData = await removeReward({ rewardIds: rewardIdsToDelete });

  //       if (removedData.some(res => res.success)) {
  //         const successfulDeletes = removedData.filter(res => res.success).length;
  //         messageShow(`${successfulDeletes} reward(s) deleted successfully.`);
  //         this.refreshReward();
  //         this.setState({ selectedRewards: {} });
  //       }
  //     } catch (error) {
  //       messageShow("Some error occurred. Please try again.");
  //     }
  //   }
  // };

  handleLeadStatusChange = async (contactId, newStatus) => {
    try {
        const { data } = await updateLeadStatus({
            contactId,
            LeadStatus: newStatus,
        });
        if (data.success) {
            this.props.messageShow(data.message || "Lead status updated successfully.");

            this.setState((prevState) => {
                const contactToUpdate = prevState.contacts.find(contact => contact._id === contactId) || prevState.leads.find(contact => contact._id === contactId) || prevState.prospects.find(contact => contact._id === contactId) || prevState.customers.find(contact => contact._id === contactId);
                const updatedContacts = prevState.contacts.filter(contact => contact._id !== contactId);
                const updatedLeads = prevState.leads.filter(contact => contact._id !== contactId);
                const updatedProspects = prevState.prospects.filter(contact => contact._id !== contactId);
                const updatedCustomers = prevState.customers.filter(contact => contact._id !== contactId);

                let newCategoryContacts;
                switch (newStatus) {
                    case "Contact":
                        newCategoryContacts = [...updatedContacts, { ...contactToUpdate, leadStatus: newStatus }];
                        return { contacts: newCategoryContacts, leads: updatedLeads, prospects: updatedProspects, customers: updatedCustomers };
                    case "Lead":
                        newCategoryContacts = [...updatedLeads, { ...contactToUpdate, leadStatus: newStatus }];
                        return { contacts: updatedContacts, leads: newCategoryContacts, prospects: updatedProspects, customers: updatedCustomers};
                    case "Prospect":
                        newCategoryContacts = [...updatedProspects, { ...contactToUpdate, leadStatus: newStatus }];
                        return { contacts: updatedContacts, leads: updatedLeads, prospects: newCategoryContacts, customers: updatedCustomers };
                    case "Customer":
                        newCategoryContacts = [...updatedCustomers, { ...contactToUpdate, leadStatus: newStatus }];
                        return { contacts: updatedContacts, leads: updatedLeads, prospects: updatedProspects, customers: newCategoryContacts };
                    default:
                        return prevState;
                }
            });
        } else {
            this.props.messageShow(data.message || "Failed to update lead status.");
        }
    } catch (error) {
        console.error("Error updating lead status:", error);
        this.props.messageShow("An error occurred. Please try again.");
    }
  };

  downloadCSV = () => {
    const { contacts, leads, prospects, customers, allLoadedContacts } = this.state;
    const allContacts = allLoadedContacts || [...contacts, ...leads, ...prospects, ...customers];

    if (allContacts.length === 0) return;

    const headers = [
      "Store Name",
      "Image",
      "Contact Name",
      "Phone Number",
      "Email",
      "Address",
      "Pin Code",
      "Lead Status",
      "Assigned To",
      "Customer Type",
      "Region",
      "Lead Source",
      "Tags",
      "Business Size",
      "Business Description",
      "Industry Type",
      "Business Website",
      "Social Media Links",
      "Year Established",
      "Employee Count",
      "Store Growth Stage",
      "Products & Services Offered",
    ];

    const csvData = allContacts.map((contact) => [
      contact.storeName || "",
      contact.image || "",
      contact.contactName || "",
      contact.phoneNumber || "",
      contact.email || "",
      contact.address || "",
      contact.pincode || "",
      contact.leadStatus || "",
      formatAssigneeName(contact.assignedTo) || "",
      contact.customerType || "",
      contact.region || "",
      contact.leadSource || "Manual",
      (contact.tags || []).join("; "),
      contact.businessType || "",
      contact.businessDescription || "",
      contact.industryType || "",
      contact.businessWebsite || "",
      Object.values(contact.socialMediaLinks || {}).join(","),
      contact.yearEstablished || "",
      contact.employeeCount || "",
      contact.storeGrowthStage || "",
      Array.isArray(contact.productsServicesOffered)
        ? contact.productsServicesOffered.join("; ")
        : contact.productsServicesOffered || "",
    ]);

    const csvContent = [
      headers.join(","),
      ...csvData.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `contacts_${new Date().toISOString().split("T")[0]}.csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  handleSelect = (newValue) => {
    const params = new URLSearchParams(this.props.location.search);
    params.set("tab", newValue);
    params.delete("page");
    this.props.history.replace({ search: params.toString() });
    this.setState({ activeTab: newValue });
  };

  renderCreateButton = () => {
    const {activeTab, permissions} = this.state
    const permissionKey = `${activeTab.toLowerCase()}Permissions`;
    const creatable = permissions[permissionKey]?.canCreate
    let currentPath = "/crm/create";
    let titleText = "Create Contacts";


    return (
      <div>
        { creatable &&
        <Link
          to={{
            pathname: `${currentPath}/${activeTab.toLowerCase()}`,
            state: {
              activeTab,
              permissions,
              availableTags: Array.from(new Set((this.state.allLoadedContacts || []).flatMap(c => c.tags || []))),
            },
          }}
        >
          <Tooltip title={titleText}>
            <IconButton sx={{ color: '#0d3559' }} disabled={!creatable}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </Link>
        }
        <Tooltip title="Upload contact">
          <IconButton
            onClick={() => this.props.history.push("/crm/bulkUpload")}
            sx={{ color: '#0d3559' }}
            disabled={!permissions?.crmPermissions?.canCreate}
          >
            <FileUpload />
          </IconButton>
        </Tooltip>
        <Tooltip title="Download CSV">
          <IconButton
            onClick={this.downloadCSV}
            sx={{ color: '#0d3559' }}
            disabled={this.state.contacts.length === 0}
          >
            <FileDownload />
          </IconButton>
        </Tooltip>
        <Link
          to="/crm/yelp"
          style={{
            pointerEvents: permissions?.yelpPermissions?.canCreate ? 'auto' : 'none',
            color: permissions?.yelpPermissions?.canCreate ? 'inherit' : 'grey',
          }}
        >
          <Tooltip title="Yelp Search" arrow>
            <IconButton sx={{ color: '#d32323' }} disabled={!permissions?.yelpPermissions?.canCreate}>
              <YelpIcon />
            </IconButton>
          </Tooltip>
        </Link>
        {permissions?.clientConfigPermissions?.canView && (
          <Link to="/crm/clientConfig">
            <Tooltip title="Client Configuration" arrow>
              <IconButton color="primary">
                <Settings />
              </IconButton>
            </Tooltip>
          </Link>
        )}
        <Tooltip title="View Email Unsubscribed List (Contacts)" arrow>
          <Button
            variant="outlined"
            size="small"
            onClick={() => this.props.history.push('/crm/unsubscribed')}
            startIcon={<UnsubscribeIcon sx={{ color: '#dc2626' }} />}
            sx={{
              borderColor: '#fca5a5',
              color: '#b91c1c',
              bgcolor: '#fff5f5',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.825rem',
              borderRadius: '8px',
              px: 1.5,
              py: 0.5,
              ml: 1,
              '&:hover': {
                bgcolor: '#fee2e2',
                borderColor: '#f87171',
              },
            }}
          >
            Email Unsubscribed List {this.state.unsubscribed?.length > 0 ? `(${this.state.unsubscribed.length})` : ''}
          </Button>
        </Tooltip>
      </div>
    );
  };
  
  render() {
    const { activeTab, contacts, leads, prospects, customers, unsubscribed = [], isLoading, permissions, filters, templates } =
      this.state;

    const totalItems = contacts.length + leads.length + prospects.length + customers.length;
    // Icon mapping could be improved by passing icons from parent or importing here.
    // For now, I'll use placeholders or imports if available.

    return (
      <Container fluid style={{ padding: '20px' }}>
        <Row className="mb-4">
            <Col md={3}>
                <StatsCard title="CONTACTS" count={contacts.length} total={totalItems} color="#0d3559" icon={<ContactIcon />} />
            </Col>
            <Col md={3}>
                <StatsCard title="LEADS" count={leads.length} total={totalItems} color="#0284c7" icon={<LeadIcon />} />
            </Col>
            <Col md={3}>
                <StatsCard title="PROSPECTS" count={prospects.length} total={totalItems} color="#ea580c" icon={<ProspectIcon />} />
            </Col>
            <Col md={3}>
                <StatsCard title="CUSTOMERS" count={customers.length} total={totalItems} color="#16a34a" icon={<CustomerIcon />} />
            </Col>
        </Row>
        <Row className="mb-10 justify-content-center">
          <Col>
            <Box className="d-flex" sx={{ borderBottom: 1, borderColor: 'divider', mb: 3, alignItems: 'center', flexWrap: 'nowrap', gap: 1 }}>
              <Tabs
                value={activeTab}
                onChange={(event, newValue) => this.handleSelect(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                    flexGrow: 1,
                    '& .MuiTab-root': {
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '0.95rem',
                        minWidth: 100,
                        color: '#64748b',
                        '&.Mui-selected': {
                            color: '#0d3559',
                        }
                    },
                    '& .MuiTabs-indicator': {
                        backgroundColor: '#0d3559',
                        height: 3,
                        borderRadius: '3px 3px 0 0'
                    }
                }}
              >
                {permissions?.contactsPermissions?.canView && <Tab value="Contacts" label="Contacts" />}
                {permissions?.leadsPermissions?.canView && <Tab value="Leads" label="Leads" />}
                {permissions?.prospectPermissions?.canView && <Tab value="Prospect" label="Prospect" />}
                {permissions?.customerPermissions?.canView && <Tab value="Customer" label="Customer" />}
              </Tabs>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0, flexWrap: 'nowrap' }}>
                <Tooltip
                  title={
                    <Box sx={{ p: 0.75, maxWidth: 300 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: "12px", mb: 0.75, color: "#ffffff" }}>
                        Search available across:
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        <Chip size="small" label="Name" sx={{ bgcolor: "rgba(255,255,255,0.18)", color: "#fff", fontSize: "11px", height: 21, fontWeight: 500 }} />
                        <Chip size="small" label="Email" sx={{ bgcolor: "rgba(255,255,255,0.18)", color: "#fff", fontSize: "11px", height: 21, fontWeight: 500 }} />
                        <Chip size="small" label="Phone" sx={{ bgcolor: "rgba(255,255,255,0.18)", color: "#fff", fontSize: "11px", height: 21, fontWeight: 500 }} />
                        <Chip size="small" label="Assigned To" sx={{ bgcolor: "rgba(255,255,255,0.18)", color: "#fff", fontSize: "11px", height: 21, fontWeight: 500 }} />
                      </Box>
                    </Box>
                  }
                  arrow
                  placement="bottom-start"
                >
                  <TextField
                    variant="outlined"
                    placeholder="Search by Name, Email, Phone, Assignee..."
                    size="small"
                    value={filters.searchTerm || ""}
                    onChange={(e) => this.setFilters({ searchTerm: e.target.value })}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search sx={{ color: '#0d3559', fontSize: 19 }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end" sx={{ gap: 0.5 }}>
                          {filters.searchTerm && (
                            <IconButton
                              size="small"
                              onClick={() => this.setFilters({ searchTerm: "" })}
                              sx={{ p: "2px", color: "#94a3b8", "&:hover": { color: "#0d3559" } }}
                            >
                              <Close sx={{ fontSize: "16px" }} />
                            </IconButton>
                          )}
                          <InfoOutlined sx={{ fontSize: 16, color: '#94a3b8', cursor: 'help' }} />
                        </InputAdornment>
                      ),
                      sx: { 
                        borderRadius: '10px', 
                        bgcolor: '#ffffff',
                        fontSize: '13px',
                        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.04)',
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#e2e8f0',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#cbd5e1',
                        },
                        '&.Mui-focused': {
                          boxShadow: '0 0 0 3px rgba(13, 53, 89, 0.08)',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#0d3559',
                            borderWidth: '1.5px',
                          },
                        },
                      }
                    }}
                    sx={{ width: { xs: 160, sm: 220, md: 300, lg: 380 } }}
                  />
                </Tooltip>
                <FiltersPopover 
                  filters={filters} 
                  setFilters={this.setFilters} 
                  clearFilters={this.clearFilters} 
                  availableTags={Array.from(new Set((this.state.allLoadedContacts || []).flatMap(c => c.tags || [])))} 
                  availableIndustryTypes={Array.from(new Set((this.state.allLoadedContacts || []).map(c => c.industryType).filter(Boolean)))} 
                />
                {this.renderCreateButton()}
              </Box>
            </Box>
            {isLoading ? (
              <BrandedLoading />
            ) : (
              <>
                {activeTab === "Contacts" && (
                  <Contacts
                    contacts={contacts}
                    onDelete={this.onDelete}
                    handleLeadStatusChange={this.handleLeadStatusChange}
                    tab = {"Contacts"}
                    permissions={permissions.contactsPermissions}
                    allPermissions = {permissions}
                    clientConfigPermissions = {permissions.clientConfigPermissions}
                    filters={filters}
                    templates={templates}
                    onSendClick = {this.handleSendClick}
                    onRefresh={this.refresh}
                  />
                )}
                {activeTab === "Leads" && (
                  <Contacts
                    contacts={leads}
                    onDelete={this.onDelete}
                    handleLeadStatusChange={this.handleLeadStatusChange}
                    tab={"Leads"}
                    permissions={permissions.leadsPermissions}
                    allPermissions = {permissions}
                    clientConfigPermissions = {permissions.clientConfigPermissions}
                    filters={filters}
                    templates={templates}
                    onSendClick = {this.handleSendClick}
                    onRefresh={this.refresh}
                  />
                )}
                {activeTab === "Prospect" && (
                  <Contacts
                    contacts={prospects}
                    onDelete={this.onDelete}
                    handleLeadStatusChange={this.handleLeadStatusChange}
                    tab={"Prospect"}
                    permissions={permissions.prospectPermissions}
                    allPermissions = {permissions}
                    clientConfigPermissions = {permissions.clientConfigPermissions}
                    filters={filters}
                    activeTab={activeTab}
                    templates={templates}
                    onSendClick = {this.handleSendClick}
                    onRefresh={this.refresh}
                  />
                )}
                {activeTab === "Customer" && (
                  <Contacts
                    contacts={customers}
                    onDelete={this.onDelete}
                    handleLeadStatusChange={this.handleLeadStatusChange}
                    tab={"Customer"}
                    permissions={permissions.customerPermissions}
                    allPermissions={permissions}
                    clientConfigPermissions = {permissions.clientConfigPermissions}
                    filters={filters}
                    templates={templates}
                    onSendClick = {this.handleSendClick}
                    onRefresh={this.refresh}
                  />
                )}
                {activeTab === "Unsubscribed" && (
                  <Contacts
                    contacts={unsubscribed}
                    onDelete={this.onDelete}
                    handleLeadStatusChange={this.handleLeadStatusChange}
                    tab={"Unsubscribed"}
                    permissions={{ canView: true, canEdit: permissions?.contactsPermissions?.canEdit, canDelete: permissions?.contactsPermissions?.canDelete !== false }}
                    allPermissions={permissions}
                    clientConfigPermissions={permissions.clientConfigPermissions}
                    filters={filters}
                    templates={templates}
                    onSendClick={this.handleSendClick}
                    onRefresh={this.refresh}
                  />
                )}
              </>
            )}
          </Col>
        </Row>
        <TemplateSelectionPopup
          open={this.state.templatePopupOpen}
          onClose={this.handleCloseTemplatePopup}
          contactId={this.state.selectedContactId}
          templates={this.state.templates.filter(t => !t.isDefault)}
          type={'CRM'}
        />
      </Container>
    );
  }
}

List.propTypes = {
  listContact: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
};

export default withRouter(connect(null, { listContact, messageShow, remove})(List));